import React from 'react';
import PropTypes from 'prop-types';

import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import ShortDateTime from 'common/ShortDateTime';

const PreviousItemList = ({ items }) => {
    if(items.length === 0) {
        return null;
    }

    return (
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell>Submitted time</TableCell>
                    <TableCell>Occupied in system</TableCell>
                    <TableCell>Occupied in reality</TableCell>
                    <TableCell>Status</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    items.map(item => (
                        <TableRow key={item.id}>
                            <TableCell><ShortDateTime value={item.modifiedTime}/></TableCell>
                            <TableCell>{item.occupiedInSystem ? 'yes' : 'no'}</TableCell>
                            <TableCell>{item.occupiedInReality ? 'yes' : 'no'}</TableCell>
                            <TableCell>{item.adminStatus}</TableCell>
                        </TableRow>
                    ))
                }
            </TableBody>
        </Table>
    );
};

PreviousItemList.propTypes = {
    items: PropTypes.array.isRequired
};

export default PreviousItemList;
